// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"113e0d95","977":"aaeff34d"}[chunkId] + ".chunk.js";
};